<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc1">
<header>
<h2 class="h2c" epub:type="title" id="contents"><span epub:type="pagebreak" id="page_4" title="4"><span epub:type="pagebreak" id="page_5" title="5">CONTENTS</span></span></h2>
</header>
<p class="tocb"><a href="#/xhtml/intro#intro">INTRODUCTION</a></p>
<figure class="image"><img alt="Images" src="images/f0005-01.jpg"/>
<figcaption></figcaption>
</figure>
<p class="tocb"><a href="#/xhtml/veg#veg">VEGETABLES</a></p>
<figure class="image"><img alt="Images" src="images/f0005-02.jpg"/>
<figcaption></figcaption>
</figure>
<p class="tocb"><span href="#/xhtml/fish#fish" title="Link target outside of Sample">FISH &amp; MEAT</span></p>
<figure class="image"><img alt="Images" src="images/f0005-03.jpg"/>
<figcaption></figcaption>
</figure>
<p class="tocb"><span href="#/xhtml/baking#baking" title="Link target outside of Sample">BAKING</span></p>
<figure class="image"><img alt="Images" src="images/f0005-04.jpg"/>
<figcaption></figcaption>
</figure>
<p class="tocc"><span href="#/xhtml/index#index" title="Link target outside of Sample">INDEX</span></p>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2464bcda